<ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-button fill="clear" slot="start" (click)="cancel()" *ngIf="!isMandatory && activeSlide == 1">Cancel
      </ion-button>
      <ion-button fill="clear" slot="start" (click)="goToPreviousSlide()" *ngIf="activeSlide != 1">Back</ion-button>
      <ion-title *ngIf="!isMandatory">Create Business</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div sxCol sxPadding="medium" sxGap="10px" *ngIf="activeSlide == 1">
        <h1 *ngIf="isMandatory">Start by creating a business Account</h1>
        <div class="icon-header" *ngIf="!isMandatory">
            <ion-icon name="briefcase-outline"></ion-icon>
        </div>
        <input [(ngModel)]="orgName" placeholder="Enter Business Name">
        <super-button [action]="onName">Next</super-button>
    </div>

    <div class="slide" *ngIf="activeSlide == 2" sxPadding="medium">

        <ion-list>
            <ion-list-header>
                <ion-label>Choose Industry</ion-label>
            </ion-list-header>

            <ion-item button="" detail="false" *ngFor="let industry of industries" (click)="onIndustrySelected(industry._id)"
                      [hidden]="industry.parentIndustry" [disabled]="isCreatingOrg">
                <ion-label>{{industry.name}}</ion-label>
                <ion-spinner slot="end" *ngIf="creatingIndustryId === industry._id"></ion-spinner>
                <ion-icon slot="end" name="arrow-forward" *ngIf="creatingIndustryId !== industry._id"></ion-icon>
            </ion-item>

        </ion-list>
    </div>


    <div class="slide" *ngIf="activeSlide == 3">
        <img src="assets/imgs/factory_dy-0-a.svg">
        <ion-list *ngIf="!isCreatingOrg">
            <ion-list-header>
                <ion-label>Choose Sub-Industry</ion-label>
            </ion-list-header>
            <ion-item button="" detail="false" *ngFor="let industry of subIndustries" (click)="createOrg(industry._id)" [disabled]="isCreatingOrg">
                <ion-label>{{industry.name}}</ion-label>
                <ion-spinner slot="end" *ngIf="creatingIndustryId === industry._id"></ion-spinner>
                <ion-icon slot="end" name="arrow-forward" *ngIf="creatingIndustryId !== industry._id"></ion-icon>
            </ion-item>
        </ion-list>
        <div class="creating-org-spinner" *ngIf="isCreatingOrg">
            <ion-spinner></ion-spinner>
            <h1>Creating QID Business Account</h1>
        </div>
    </div>


    <!--  <img src="assets/imgs/undraw_businessman_re_mlee.svg">-->
</ion-content>
